<template>
  <div id="filter_wrap" class="sales-filter-region">
    <ErrorBox :error="x.error" />
    <FilterBoard
      class="sales-filter-panel oms-list-filter"
      eyebrow=""
      title="Sales inquiry queue"
    >
      <v-flex
        xs2
        md4
        class="oms-filter-board__field sales-filter-field sales-filter-field--type"
      >
        <v-select
          v-model="searchTypes"
          :items="searchItems"
          label="Search Type"
          item-text="status"
          class="pt-0 currencyTitle pppp"
          item-value="abbr"
          persistent-hint
          hide-details
          @change="searchByType()"
          :menu-props="salesSelectMenuProps"
          return-object
          single-line
          outline
        ></v-select>
      </v-flex>
      <v-flex
        xs2
        md3
        class="oms-filter-board__field oms-filter-board__field--search sales-filter-field sales-filter-field--search"
      >
        <v-text-field
          height="2.5rem"
          class="gap Bottom_2px"
          inputmode="search"
          type="search"
          placeholder="Search here..."
          outline
          :disabled="!searchTypes"
          hide-details
          single-line
          v-model="search"
          @keyup.enter="searchAnything"
          @click:append="searchAnything"
          append-icon="search"
        ></v-text-field>
      </v-flex>
      <v-flex
        xs3
        pl-2
        pr-2
        class="wrapper oms-filter-board__field oms-filter-board__field--date sales-filter-field sales-filter-field--date"
        :class="{ 'sales-filter-field--date-applied': dateRangeLabel }"
        id="accountDate"
        :data-range-tooltip="dateRangeLabel"
      >
        <ejs-daterangepicker
          :placeholder="waterMark"
          v-model="dateRange2"
          format="yyyy-MM-dd"
          separator=" to "
          :htmlAttributes="{ 'aria-label': dateRangeLabel || waterMark }"
        ></ejs-daterangepicker>
      </v-flex>
      <!-- <v-flex xs2 md2>
        <span class="muted"></span>
        <v-menu
          ref="FilterDateBool"
          lazy
          v-model="FilterDateBool"
          :close-on-content-click="false"
          transition="scale-transition"
          full-width
          :nudge-right="40"
          min-width="290px"
          :return-value.sync="startDate"
        >
          <v-text-field
            slot="activator"
            :label="'Start date'"
            required
            v-model="startDate"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker
            v-model="startDate"
            class="minHeight"
            @change="
              $refs.FilterDateBool.save(startDate);
              searchByDate();
            "
            no-title
            scrollable
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs2 pr-2>
        <span class="muted"></span>
        <v-menu
          ref="FilterEndDateBool"
          lazy
          v-model="FilterEndDateBool"
          :close-on-content-click="false"
          transition="scale-transition"
          full-width
          :nudge-right="40"
          min-width="290px"
          :return-value.sync="endDate"
        >
          <v-text-field
            slot="activator"
            :label="'End date'"
            required
            v-model="endDate"
            prepend-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker
            v-model="endDate"
            class="minHeight"
            @change="
              $refs.FilterEndDateBool.save(endDate);
              searchByDate();
            "
            no-title
            scrollable
          ></v-date-picker>
        </v-menu>
      </v-flex> -->
      <v-flex
        xs2
        pr-2
        class="oms-filter-board__field sales-filter-field sales-filter-field--job"
      >
        <v-select
          v-model="jobType"
          :items="JobListTypes"
          label="Job Type"
          persistent-hint
          hide-details
          @change="searchByJobType"
          :menu-props="salesSelectMenuProps"
          single-line
        ></v-select>
      </v-flex>
      <v-flex
        xs2
        class="oms-filter-board__field sales-filter-field sales-filter-field--status"
      >
        <v-autocomplete
          v-model="inquiryStatus"
          :items="inquiryStatusType"
          label="Inquiry Status"
          hide-details
          @change="statusFilter"
          :menu-props="salesSelectMenuProps"
          single-line
        ></v-autocomplete>
      </v-flex>
      <v-flex
        xs2
        pr-1
        pl-1
        class="oms-filter-board__field sales-filter-field sales-filter-field--inquiry"
      >
        <v-select
          v-model="isConvertedInquiry"
          :items="inquiryTypeList"
          label="Inquiry Type"
          persistent-hint
          hide-details
          @change="searchByInquiryType"
          :menu-props="salesSelectMenuProps"
          single-line
        ></v-select>
      </v-flex>

      <!-- <v-flex xs1 class="reset"></v-flex> -->
      <v-flex
        xs3
        md2
        pl-2
        class="oms-filter-board__field oms-filter-board__field--wide sales-filter-field sales-filter-field--executive"
        v-permissions="'assign-executive'"
      >
        <div id="multiselect-sample">
          <div class="col-lg-4 control-section">
            <div class="control-styles">
              <ejs-multiselect
                id="multiselect-checkbox"
                :dataSource="executives"
                :fields="fields"
                :placeholder="checkWaterMark"
                :mode="multiMode"
                v-model="salesExecutive"
                cssClass="sales-executive-multiselect"
                :closePopupOnSelect="false"
                :showClearButton="false"
                popupWidth="260px"
                :popupHeight="popHeight"
                :showDropDownIcon="showDropDownIcon"
                :showSelectAll="showSelectAll"
                :filterBarPlaceholder="filterPlaceholder"
                :enableSelectionOrder="enableSelectionOrder"
              ></ejs-multiselect>
            </div>
          </div>
        </div>

        <!-- <v-autocomplete
          v-model="salesExecutive"
          :items="executives"
          :disabled="searchStatus"
          label="Filter by Sales Executive"
          single-line
          multiple
          @click="check()"
        ></v-autocomplete> -->
      </v-flex>
      <v-flex xs1 class="reset oms-filter-board__actions sales-filter-actions">
        <v-btn
          class="reset-btn-color oms-filter-board__reset"
          flat
          prepend-icon
          color="orange darken-1"
          @click.native="reset()"
        >
          Reset
          <!-- <v-icon color="orange">donut_large</v-icon> -->
        </v-btn>
      </v-flex>
    </FilterBoard>
  </div>
</template>
<script>
import Vue from "vue";
import { EventBus } from "../../event-bus.js";
import ErrorBox from "@/components/Common/ErrorBox";
import FilterBoard from "@/components/Common/FilterBoard";
import { DateRangePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import removeLocalstorageMixin from "@/mixins/removeLocalstorageMixin";
import {
  MultiSelectPlugin,
  CheckBoxSelection,
} from "@syncfusion/ej2-vue-dropdowns";
// import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons';
import moment from "moment";
Vue.use(DateRangePickerPlugin);

import DateRangePicker from "vue2-daterange-picker";
import { StorageKeys, JobListTypes } from "../../constants/constants";
Vue.use(MultiSelectPlugin);

// Vue.use(ButtonPlugin);

export default {
  mixins: [removeLocalstorageMixin],
  name: "customFilterCustomer",
  components: {
    ErrorBox,
    FilterBoard,
    DateRangePicker,
  },
  created() {
    if (localStorage.getItem("workingCountries")) {
      this.workingCountries = JSON.parse(
        localStorage.getItem("workingCountries")
      );
      let workingCountry = [];
      this.workingCountries.forEach((key, index) => {
        if (key.isSelected) {
          workingCountry.push(key.value);
        }
      });
      this.workingCountry = this.workingCountry =
        JSON.stringify(workingCountry);
      this.fetchExecutives();
    }
    this.removeStorage();
    localStorage.removeItem("searchSales");
    localStorage.removeItem("searchSalesType");
    localStorage.removeItem("searchex");
    localStorage.removeItem("salesJobType");
    localStorage.removeItem("startdateSales");
    localStorage.removeItem("enddateSales");
    localStorage.removeItem("payloadSales");
    // this.reset();
    this.JobListTypes = JobListTypes;

    EventBus.$on("countryChanged", (val) => {
      if (this.$route.name == "sales-section") {
        this.workingCountry = JSON.stringify(val);
        if (
          localStorage.getItem("startdateSales") !== null &&
          localStorage.getItem("enddateSales") !== null
        ) {
          this.startDate = localStorage.startdateSales;
          this.endDate = localStorage.enddateSales;
          // this.searchByDate();
        }
        if (localStorage.getItem("enddateSales") !== null) {
          this.endDate = localStorage.enddateSales;
          // this.searchByDate();
        }
        if (localStorage.getItem("salesJobType") !== null) {
          this.jobType = localStorage.salesJobType;
        }
        if (localStorage.getItem("searchSales") !== null) {
          this.search = localStorage.searchSales;
          let searchSalesType = JSON.parse(localStorage.searchSalesType);
          this.searchTypes = searchSalesType;
        }
        // if (localStorage.getItem("searchex") !== null) {
        //   this.salesExecutive = localStorage.searchex;
        //   this.searchByExecutive();
        // }
        this.fetchExecutives();
      }
    });
  },
  computed: {
    dateRangeLabel() {
      if (this.startDate && this.endDate) {
        return `${this.startDate} to ${this.endDate}`;
      }
      return "";
    },
  },
  watch: {
    salesExecutive(val) {
      if (val) {
        if (val && val.length) {
          let allSalesExecutive =
            val.length === this.executives.length ? "true" : "false";

          //localStorage.setItem("searchex", this.salesExecutive);

          this.$emit("request-executiveFilter", {
            salesExecutive: val,
            allSalesExecutive: allSalesExecutive,
          });
        } else if (!val.length) {
          this.$emit("request-executiveFilter", {
            salesExecutive: [],
            allSalesExecutive: false,
          });
        }
      }
    },
    dateRange2(val) {
      if (val && val[0] && val[1]) {
        this.startDate = moment(val[0]).format("YYYY-MM-DD");
        this.endDate = moment(val[1]).format("YYYY-MM-DD");
        this.$emit("request-startDateFilter", this.formatDate(this.startDate));
        this.$emit("request-endDateFilter", this.formatDate(this.endDate));
      } else if (!val) {
        this.startDate = "";
        this.endDate = "";
        this.$emit("request-startDateFilter", this.startDate);
        this.$emit("request-endDateFilter", this.endDate);
      }
    },
  },
  data() {
    return {
      checkWaterMark: "Select Sales Executive",
      waterMark: "Select a Range",
      dateRange: { startDate: "", endDate: "" },
      dateRange2: null,
      startDate: "",
      endDate: "",

      popHeight: "280px",
      selectAll: Boolean,
      multiMode: "CheckBox",

      filterPlaceholder: "Search Executive",
      salesSelectMenuProps: {
        allowOverflow: true,
        contentClass: "sales-filter-menu",
        maxHeight: 280,
        nudgeBottom: 4,
        offsetY: true,
      },
      isConvertedInquiry: "",
      inquiryTypeList: [
        { text: "Converted", value: "true" },
        { text: "Pending", value: "false" },
      ],

      showSelectAll: true,
      showDropDownIcon: true,
      enableSelectionOrder: false,
      workingCountry: null,
      JobListTypes: [],
      isReset: null,
      opeartionName: "",
      searchStatus: false,
      jobType: "",
      FilterDateBool: false,
      FilterEndDateBool: false,
      name: "",
      executives: [],
      startDate: "",
      endDate: "",
      search: "",
      salesExecutive: [],
      fields: { text: "text", value: "value" },
      select: { country: "", abbr: "" },
      x: {
        error: null,
      },
      items: [
        { country: "India", abbr: "IN" },
        { country: "United Arab Emirates", abbr: "UAE" },
        { country: "USA", abbr: "USA" },
        { country: "UK", abbr: "UK" },
      ],
      inquiryStatusType: [
        { text: "Low Credit Limit", value: "Low Credit Limit" },
        { text: "Inquiry Received", value: "Inquiry Received" },
        { text: "Customer Rate Accepted", value: "Customer Rate Accepted" },
        { text: "Reopen", value: "Reopen" },
        { text: "Delayed", value: "Delay" },
        { text: "Lead Lost", value: "Lead lost" },
      ],
      inquiryStatus: "",
      searchItems: [
        {
          status: "Company/Customer Name",
          abbr: "companyName/customerName",
        },
        { status: "Inquiry ID", abbr: "inquiryId" },
        { status: "Customer Email ID", abbr: "custEmailId" },
      ],
      searchTypes: "",
    };
  },
  methods: {
    async check() {
      this.operationName = "assign-executive";
      let y = await this.checkOpertaionPermission(this.operationName);
      if (y) {
        this.searchByExecutive();
      } else {
        return;
      }
    },
    fetchExecutives() {
      let url = `/sales/executiveList?workingCountry=${[this.workingCountry]}`;
      delete this.axios.defaults.headers.common["token"];
      let token = localStorage.getItem(StorageKeys.SessionKey);
      let config = {
        headers: {
          authorization: `bearer ${token}`,
        },
      };
      this.axios
        .get(
          this.constants.apiUrl + url,

          config
        )
        .then(
          (response) => {
            response.data.data.forEach((e) => {
              this.executives.push({ value: e._id, text: e.name });
            });
          },
          (error) => {
            // this.x.error = "Failed to Fetch User Details";
          }
        );
    },
    reset() {
      localStorage.removeItem("searchSales");
      localStorage.removeItem("searchSalesType");
      localStorage.removeItem("searchex");
      localStorage.removeItem("salesJobType");
      localStorage.removeItem("startdateSales");
      localStorage.removeItem("enddateSales");
      localStorage.removeItem("payloadSales");
      this.startDate = "";
      this.endDate = "";
      this.inquiryStatus = "";
      this.jobType = "";
      this.select = { country: "", abbr: "" };
      this.search = "";
      this.isConvertedInquiry = "";
      this.salesExecutive = [];
      this.dateRange2 = null;
      this.startDate = "";
      this.endDate = "";
      this.searchTypes = "";
      this.$emit(
        "customer-reset",
        this.search ||
          this.jobType ||
          this.inquiryStatus ||
          this.salesExecutive ||
          this.searchTypes.abbr
      );
    },
    searchByInquiryType() {
      this.$emit("isConvertedInquiry", this.isConvertedInquiry);
    },
    filterByCountry() {
      this.$emit("customer-countryFilter", this.select.country);
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    searchByExecutive(value) {
      return;
      if (this.salesExecutive.length) {
        let allSalesExecutive =
          this.salesExecutive.length === this.executives.length
            ? "true"
            : "false";
        if (this.salesExecutive == localStorage.getItem("searchex")) {
          return;
        } else {
          localStorage.setItem("searchex", this.salesExecutive);
          this.$emit("request-executiveFilter", {
            salesExecutive: this.salesExecutive,
            allSalesExecutive: allSalesExecutive,
          });
        }
      } else {
        localStorage.setItem("searchex", this.salesExecutive);
        this.$emit("request-executiveFilter", {
          salesExecutive: this.salesExecutive,
          allSalesExecutive: false,
        });
      }
    },
    searchByJobType() {
      if (this.jobType) {
        //  localStorage.setItem("salesJobType", this.jobType);
        this.$emit("jobType", this.jobType);
      }
    },

    searchByDate() {
      if (
        this.startDate == localStorage.getItem("startdateSales") &&
        this.endDate == localStorage.getItem("enddateSales")
      ) {
        return;
      }
      if (this.endDate && this.startDate) {
        localStorage.setItem("startdateSales", this.startDate);
        localStorage.setItem("enddateSales", this.endDate);

        var start = +new Date(this.startDate);
        var end = +new Date(this.endDate);

        if (end < start) {
          this.x.error = "End Date cannot be less than Start Date.";
        } else {
          this.$emit(
            "request-startDateFilter",
            this.formatDate(this.startDate)
          );
          this.$emit("request-endDateFilter", this.formatDate(this.endDate));
        }
      } else {
        this.x.error = "Both Start Date and End Date is required.";
      }
    },
    searchAnything() {
      localStorage.setItem("searchSales", this.search);
      localStorage.setItem("searchSalesType", JSON.stringify(this.searchTypes));

      this.$emit("customer-search", this.search.trim());
      this.$emit("customer-searchType", this.searchTypes.abbr);
    },
    searchByType() {
      this.search = "";
      //  localStorage.setItem("searchSales", this.search);
      // localStorage.setItem("searchSalesType", JSON.stringify(this.searchTypes));
      this.$emit("customer-search", this.search);
      this.$emit("customer-searchType", this.searchTypes.abbr);
    },
    statusFilter() {
      this.$emit("inquiry-status", this.inquiryStatus);
    },
  },
  provide: {
    multiselect: [CheckBoxSelection],
  },
};
</script>
<style lang="scss">
div#ej2-datetimepicker_0_popup {
}
#accountDate .e-clear-icon {
  display: none !important;
  opacity: 0;
}
#accountDate ::placeholder {
  font-size: 0.8125rem;
  color: #334155 !important;
  font-family: inherit !important;
  font-weight: 500 !important;
  letter-spacing: 0;
  opacity: 1;
}
.e-multiselect.e-input-group.e-control-wrapper.e-checkbox {
  width: 100% !important;
}
.e-input-group.e-control-wrapper:not(.e-float-icon-left):not(.e-float-input)::before {
  background: #ea7a1c !important;
}
.e-input-group.e-control-wrapper:not(.e-float-icon-left):not(.e-float-input)::after {
  background: #ea7a1c !important;
}
div.e-input-focus::before,
div.e-input-focus::after {
  background: #ea7a1c !important;
}
.e-multi-select-wrapper .e-close-icon-hide .e-down-icon {
  background: #ea7a1c !important;
}

.e-input-in-wrap::after {
  background: #ea7a1c !important;
}
.e-checkbox-wrapper .e-frame.e-check,
.e-css.e-checkbox-wrapper .e-frame.e-check {
  background-color: #ea7a1c !important;
}
input.e-dropdownbase::placeholder {
  font-size: 0.8125rem;
  color: #334155 !important;
  font-family: inherit !important;
  font-weight: 500 !important;
  letter-spacing: 0;
  opacity: 1;
}
.inquiry {
  max-height: 19.375rem !important;
}

.sales-filter-menu.v-menu__content {
  border: 0.0625rem solid #e4e1d9 !important;
  border-radius: 0.5rem !important;
  box-shadow: 0 1rem 2.25rem rgba(23, 32, 51, 0.14) !important;
  margin-top: 0.25rem;
  overflow: hidden;
}

.sales-filter-menu .v-list {
  background: #ffffff !important;
  padding: 0.25rem !important;
}

.sales-filter-menu .v-list__tile {
  border-radius: 0.375rem;
  height: auto !important;
  min-height: 2.125rem;
  padding: 0 0.625rem !important;
}

.sales-filter-menu .v-list__tile:hover,
.sales-filter-menu .v-list__tile--highlighted {
  background: #fff7ed !important;
}

.sales-filter-menu .v-list__tile--active {
  background: #fdf0e4 !important;
  color: #d96a10 !important;
}

.sales-filter-menu .v-list__tile__title {
  color: #334155;
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
}

.e-popup.sales-executive-multiselect,
#multiselect-checkbox_popup {
  background: #ffffff !important;
  border: 0.0625rem solid #e4e1d9 !important;
  border-radius: 0.5rem !important;
  box-shadow: 0 1rem 2.25rem rgba(23, 32, 51, 0.14) !important;
  color: #334155;
  max-height: 24rem;
  max-width: 22rem;
  overflow: hidden;
  width: calc(100vw - 2rem);
}

@media (max-height: 29rem) {
  .e-popup.sales-executive-multiselect,
  #multiselect-checkbox_popup {
    max-height: calc(100vh - 5rem);
  }
}

.e-popup.sales-executive-multiselect .e-list-item,
.e-popup.sales-executive-multiselect .e-selectall-parent,
#multiselect-checkbox_popup .e-list-item,
#multiselect-checkbox_popup .e-selectall-parent {
  min-height: 2.125rem;
}

.e-popup.sales-executive-multiselect .e-filter-parent,
#multiselect-checkbox_popup .e-filter-parent {
  border-bottom: 0.0625rem solid #edf0f5;
  padding: 0.5rem;
}

.e-popup.sales-executive-multiselect .e-filter-parent .e-input-group,
#multiselect-checkbox_popup .e-filter-parent .e-input-group {
  align-items: center;
  border: 0.0625rem solid #dbe2ec !important;
  border-radius: 0.5rem;
  box-shadow: none !important;
  display: flex;
  height: 2.25rem;
  padding: 0 0.625rem;
}

.e-popup.sales-executive-multiselect .e-filter-parent input,
.e-popup.sales-executive-multiselect .e-filter-parent input::placeholder,
#multiselect-checkbox_popup .e-filter-parent input,
#multiselect-checkbox_popup .e-filter-parent input::placeholder {
  color: #334155 !important;
  font-family: inherit !important;
  font-size: 0.8125rem !important;
  font-weight: 500 !important;
  letter-spacing: 0;
  opacity: 1 !important;
}

.e-popup.sales-executive-multiselect .e-list-parent,
#multiselect-checkbox_popup .e-list-parent {
  max-height: 15rem;
  overflow-y: auto;
  padding: 0.25rem;
}

.e-popup.sales-executive-multiselect .e-list-item,
#multiselect-checkbox_popup .e-list-item {
  align-items: center;
  border-radius: 0.375rem;
  display: flex;
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1.25;
  margin: 0.125rem 0;
  padding: 0.4375rem 0.625rem;
}

.e-popup.sales-executive-multiselect .e-list-item.e-active,
.e-popup.sales-executive-multiselect .e-list-item.e-hover,
#multiselect-checkbox_popup .e-list-item.e-active,
#multiselect-checkbox_popup .e-list-item.e-hover {
  background: #fff7ed !important;
  color: #d96a10 !important;
}

.e-popup.sales-executive-multiselect .e-list-item .e-list-text,
.e-popup.sales-executive-multiselect .e-all-text,
#multiselect-checkbox_popup .e-list-item .e-list-text,
#multiselect-checkbox_popup .e-all-text {
  color: inherit;
  display: inline-block;
  font-family: inherit;
  font-size: 0.8125rem;
  font-weight: 700;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
}

.e-popup.sales-executive-multiselect .e-selectall-parent,
#multiselect-checkbox_popup .e-selectall-parent {
  align-items: center;
  border-bottom: 0.0625rem solid #edf0f5;
  display: flex !important;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 0.5rem;
  min-height: 2.125rem;
  padding: 0.5rem 0.75rem;
  white-space: nowrap;
}

.e-popup.sales-executive-multiselect .e-selectall-parent .e-checkbox-wrapper,
.e-popup.sales-executive-multiselect .e-selectall-parent .e-css.e-checkbox-wrapper,
#multiselect-checkbox_popup .e-selectall-parent .e-checkbox-wrapper,
#multiselect-checkbox_popup .e-selectall-parent .e-css.e-checkbox-wrapper {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  margin-right: 0;
  vertical-align: middle;
  width: auto;
}

.e-popup.sales-executive-multiselect .e-selectall-parent .e-all-text,
#multiselect-checkbox_popup .e-selectall-parent .e-all-text {
  display: inline-block;
  flex: 1 1 auto;
  margin: 0;
  min-width: 0;
}

.e-popup.sales-executive-multiselect .e-checkbox-wrapper,
.e-popup.sales-executive-multiselect .e-css.e-checkbox-wrapper,
#multiselect-checkbox_popup .e-checkbox-wrapper,
#multiselect-checkbox_popup .e-css.e-checkbox-wrapper {
  align-items: center;
  display: inline-flex;
  margin-right: 0.5rem;
}

.e-popup.sales-executive-multiselect .e-checkbox-wrapper .e-frame,
.e-popup.sales-executive-multiselect .e-css.e-checkbox-wrapper .e-frame,
#multiselect-checkbox_popup .e-checkbox-wrapper .e-frame,
#multiselect-checkbox_popup .e-css.e-checkbox-wrapper .e-frame {
  align-items: center;
  background: #ffffff;
  border: 0.0625rem solid #cbd5e1;
  border-radius: 0.25rem;
  box-shadow: none;
  display: inline-flex;
  height: 1rem;
  justify-content: center;
  line-height: 1;
  /* Syncfusion's 2px top/bottom padding is sized for its 18px frame and
     pushes the tick below centre in this smaller one. */
  padding: 0;
  width: 1rem;
}

.e-popup.sales-executive-multiselect .e-checkbox-wrapper .e-frame.e-check,
.e-popup.sales-executive-multiselect .e-checkbox-wrapper .e-frame.e-stop,
.e-popup.sales-executive-multiselect .e-css.e-checkbox-wrapper .e-frame.e-check,
.e-popup.sales-executive-multiselect .e-css.e-checkbox-wrapper .e-frame.e-stop,
#multiselect-checkbox_popup .e-checkbox-wrapper .e-frame.e-check,
#multiselect-checkbox_popup .e-checkbox-wrapper .e-frame.e-stop,
#multiselect-checkbox_popup .e-css.e-checkbox-wrapper .e-frame.e-check,
#multiselect-checkbox_popup .e-css.e-checkbox-wrapper .e-frame.e-stop {
  background-color: #f58220 !important;
  border-color: #f58220 !important;
  color: #ffffff !important;
}

.e-popup.sales-executive-multiselect .e-checkbox-wrapper .e-frame.e-check::before,
.e-popup.sales-executive-multiselect .e-css.e-checkbox-wrapper .e-frame.e-check::before,
#multiselect-checkbox_popup .e-checkbox-wrapper .e-frame.e-check::before,
#multiselect-checkbox_popup .e-css.e-checkbox-wrapper .e-frame.e-check::before {
  color: #ffffff !important;
  font-size: 0.6875rem;
  line-height: 1;
}

@media (max-width: 24rem) {
  .e-popup.sales-executive-multiselect,
  #multiselect-checkbox_popup {
    max-width: calc(100vw - 2rem);
  }
}
</style>
<style scoped>
.sales-filter-region {
  display: block;
}

.sales-filter-panel {
  --oms-filter-board-padding: 0.875rem;
  --sales-filter-control-height: 2.5rem;
  --sales-filter-control-inner-height: 2.375rem;
  margin: 0 var(--oms-list-section-x, 1.75rem);
}

.sales-filter-panel ::v-deep .oms-filter-board__grid {
  align-items: start;
  display: grid !important;
  gap: 0.75rem;
  grid-auto-flow: row dense;
  grid-template-columns: repeat(auto-fit, minmax(13rem, 1fr));
  width: 100%;
}

.sales-filter-panel ::v-deep .oms-filter-board__field--search,
.sales-filter-panel ::v-deep .sales-filter-field--executive {
  grid-column: span 2;
}

.sales-filter-panel ::v-deep .sales-filter-field--date {
  grid-column: span 1;
  min-width: 0;
}

.sales-filter-panel ::v-deep .oms-filter-board__field,
.sales-filter-panel ::v-deep .flex.oms-filter-board__field,
.sales-filter-panel ::v-deep .oms-filter-board__actions,
.sales-filter-panel ::v-deep .flex.oms-filter-board__actions {
  align-items: stretch;
  box-sizing: border-box;
  display: flex !important;
  flex: none !important;
  float: none !important;
  height: auto;
  margin: 0 !important;
  max-width: none !important;
  min-height: var(--sales-filter-control-height);
  min-width: 0;
  padding: 0 !important;
  width: 100% !important;
}

.sales-filter-panel ::v-deep .oms-filter-board__actions,
.sales-filter-panel ::v-deep .sales-filter-actions,
.sales-filter-panel ::v-deep .reset {
  align-self: start;
  float: none !important;
  grid-column: auto;
  justify-content: stretch;
  margin-left: 0 !important;
  margin-top: 0 !important;
  min-width: 0;
}

.sales-filter-panel ::v-deep .v-input,
.sales-filter-panel ::v-deep .v-text-field,
.sales-filter-panel ::v-deep .v-select,
.sales-filter-panel ::v-deep .v-autocomplete,
.sales-filter-panel ::v-deep .wrapper,
.sales-filter-panel ::v-deep .e-input-group,
.sales-filter-panel ::v-deep .e-control-wrapper {
  box-sizing: border-box !important;
  height: var(--sales-filter-control-height) !important;
  margin: 0 !important;
  min-height: var(--sales-filter-control-height) !important;
  padding: 0 !important;
  width: 100% !important;
}

.sales-filter-panel ::v-deep .v-input__control,
.sales-filter-panel ::v-deep .v-input__slot,
.sales-filter-panel ::v-deep .v-select__slot,
.sales-filter-panel ::v-deep .v-text-field__slot,
.sales-filter-panel ::v-deep .e-input-group,
.sales-filter-panel ::v-deep .e-control-wrapper {
  height: var(--sales-filter-control-height) !important;
  min-height: var(--sales-filter-control-height) !important;
  width: 100%;
}

.sales-filter-panel ::v-deep .v-input__slot,
.sales-filter-panel ::v-deep .e-input-group,
.sales-filter-panel ::v-deep .e-control-wrapper {
  align-items: center !important;
  background: #ffffff !important;
  border: 0.0625rem solid #dbe2ec !important;
  border-radius: 0.5rem !important;
  box-shadow: inset 0 0.0625rem 0 rgba(26, 25, 22, 0.03) !important;
  box-sizing: border-box !important;
  display: flex !important;
  padding: 0 0.75rem !important;
}

.sales-filter-panel ::v-deep .v-input__slot::before,
.sales-filter-panel ::v-deep .v-input__slot::after {
  display: none !important;
}

.sales-filter-panel ::v-deep .v-input--is-focused .v-input__slot,
.sales-filter-panel ::v-deep .e-input-focus {
  border-color: #ea7a1c !important;
  box-shadow: 0 0 0 0.1875rem rgba(245, 130, 32, 0.12) !important;
}

.sales-filter-panel ::v-deep .v-input--is-disabled .v-input__slot {
  background: #f8fafc !important;
  color: #94a3b8 !important;
  cursor: not-allowed;
}

.sales-filter-panel ::v-deep .v-text-field input,
.sales-filter-panel ::v-deep .v-select input,
.sales-filter-panel ::v-deep .e-input,
.sales-filter-panel ::v-deep input {
  color: #334155 !important;
  font-family: inherit !important;
  font-size: 0.8125rem !important;
  font-weight: 600 !important;
  height: var(--sales-filter-control-inner-height) !important;
  letter-spacing: 0 !important;
  line-height: var(--sales-filter-control-inner-height) !important;
  margin: 0 !important;
  max-height: var(--sales-filter-control-inner-height) !important;
  min-height: 0 !important;
  overflow: hidden;
  padding: 0 !important;
  text-overflow: ellipsis;
}

.sales-filter-panel ::v-deep input::placeholder,
.sales-filter-panel ::v-deep .e-input::placeholder,
.sales-filter-panel ::v-deep .e-input-group input::placeholder,
.sales-filter-panel ::v-deep .e-multi-select-wrapper input::placeholder,
.sales-filter-panel ::v-deep .e-multi-select-wrapper .e-placeholder,
.sales-filter-panel ::v-deep .e-multi-select-wrapper .e-delim-view,
.sales-filter-panel ::v-deep .e-searcher input,
.sales-filter-panel ::v-deep .e-searcher input::placeholder,
.sales-filter-panel ::v-deep .v-label {
  color: #334155 !important;
  font-family: inherit !important;
  font-size: 0.8125rem !important;
  font-weight: 500 !important;
  letter-spacing: 0 !important;
  line-height: 1.2 !important;
  opacity: 1 !important;
}

.sales-filter-panel ::v-deep .v-select__selection,
.sales-filter-panel ::v-deep .v-select__selection--comma {
  color: #334155 !important;
  font-family: inherit !important;
  font-size: 0.8125rem !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  line-height: 1.2 !important;
  opacity: 1 !important;
}

.sales-filter-panel ::v-deep #accountDate .e-input::placeholder,
.sales-filter-panel ::v-deep .sales-filter-field--date input:placeholder-shown,
.sales-filter-panel ::v-deep .sales-filter-field--executive input:placeholder-shown,
.sales-filter-panel ::v-deep .sales-executive-multiselect .e-placeholder,
.sales-filter-panel
  ::v-deep
  .sales-executive-multiselect
  .e-multi-select-wrapper
  input::placeholder {
  font-weight: 500 !important;
}

.sales-filter-panel ::v-deep .v-label {
  top: 0.625rem !important;
}

.sales-filter-panel ::v-deep .v-label--active {
  transform: translateY(-1.125rem) scale(0.75) !important;
}

.sales-filter-panel ::v-deep .v-select__selections {
  align-items: center !important;
  flex-wrap: nowrap;
  min-height: var(--sales-filter-control-inner-height) !important;
  overflow: hidden;
  padding: 0 !important;
}

.sales-filter-panel ::v-deep .v-select__selection,
.sales-filter-panel ::v-deep .v-select__selection--comma {
  line-height: 1.2;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sales-filter-panel ::v-deep .v-input__append-inner,
.sales-filter-panel ::v-deep .v-input__append-outer,
.sales-filter-panel ::v-deep .v-input__prepend-inner,
.sales-filter-panel ::v-deep .v-input__prepend-outer,
.sales-filter-panel ::v-deep .e-input-group-icon,
.sales-filter-panel ::v-deep .e-ddl-icon,
.sales-filter-panel ::v-deep .e-range-icon {
  align-items: center !important;
  align-self: center !important;
  display: inline-flex !important;
  height: var(--sales-filter-control-inner-height) !important;
  justify-content: center;
  margin: 0 !important;
  min-height: var(--sales-filter-control-inner-height) !important;
  position: static !important;
}

.sales-filter-panel ::v-deep .v-icon,
.sales-filter-panel ::v-deep .e-input-group-icon,
.sales-filter-panel ::v-deep .e-ddl-icon,
.sales-filter-panel ::v-deep .e-range-icon {
  color: #64748b !important;
  font-size: 1rem !important;
}

.sales-filter-panel ::v-deep .v-text-field__details {
  display: none !important;
}

.sales-filter-panel ::v-deep .oms-filter-board__reset,
.sales-filter-panel ::v-deep .v-btn.oms-filter-board__reset {
  background: #ffffff !important;
  border: 0.0625rem solid #dbe2ec !important;
  border-radius: 0.5rem !important;
  box-shadow: none !important;
  color: #d96a10 !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  height: var(--sales-filter-control-height) !important;
  line-height: 1 !important;
  margin: 0 !important;
  min-height: var(--sales-filter-control-height) !important;
  min-width: 0 !important;
  padding: 0 0.625rem !important;
  width: 100% !important;
}

.sales-filter-panel ::v-deep .oms-filter-board__reset:hover,
.sales-filter-panel ::v-deep .v-btn.oms-filter-board__reset:hover {
  background: #fff7ed !important;
  border-color: #f6c79b !important;
}

.sales-filter-panel ::v-deep .col-lg-4.control-section,
.sales-filter-panel ::v-deep .control-section,
.sales-filter-panel ::v-deep #multiselect-sample,
.sales-filter-panel ::v-deep .control-styles {
  box-sizing: border-box;
  flex: none !important;
  margin: 0 !important;
  max-width: none !important;
  min-width: 0;
  padding: 0 !important;
  width: 100% !important;
}

.sales-filter-panel ::v-deep .sales-executive-multiselect.e-input-group,
.sales-filter-panel
  ::v-deep
  .sales-executive-multiselect.e-input-group.e-control-wrapper {
  cursor: pointer;
}

.sales-filter-panel ::v-deep .e-multi-select-wrapper {
  align-items: center;
  display: flex;
  height: var(--sales-filter-control-inner-height) !important;
  min-height: var(--sales-filter-control-inner-height) !important;
  overflow: hidden;
  width: 100%;
}

.sales-filter-panel ::v-deep .e-multi-select-wrapper .e-chips-collection {
  max-height: 2rem;
  overflow: hidden;
}

.sales-filter-panel ::v-deep .e-multi-select-wrapper .e-chips {
  align-items: center;
  background: #fff7ed !important;
  border: 0.0625rem solid #fed7aa;
  border-radius: 999rem;
  color: #9a4f08;
  display: inline-flex;
  height: 1.5rem;
  margin: 0 0.25rem 0 0;
  max-width: 100%;
  padding: 0 0.375rem;
}

.sales-filter-panel ::v-deep .e-multi-select-wrapper .e-chips .e-chipcontent {
  color: inherit;
  font-family: inherit;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sales-filter-panel ::v-deep .e-multi-select-wrapper .e-delim-values {
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sales-filter-panel ::v-deep .e-multi-select-wrapper input[type="text"] {
  min-width: 0 !important;
}

#accountDate {
  overflow: visible;
  position: relative;
}

#accountDate::after {
  background: #fff7ed;
  border: 0.0625rem solid #fed7aa;
  border-radius: 0.5rem;
  box-shadow: 0 0.75rem 1.5rem rgba(234, 122, 28, 0.12);
  color: #9a4f08;
  content: attr(data-range-tooltip);
  font-family: inherit;
  font-size: 0.75rem;
  font-weight: 700;
  left: 0;
  letter-spacing: 0;
  line-height: 1.2;
  max-width: min(22rem, 90vw);
  opacity: 0;
  padding: 0.4375rem 0.625rem;
  pointer-events: none;
  position: absolute;
  top: calc(100% + 0.375rem);
  transform: translateY(-0.25rem);
  transition: opacity 0.15s ease, transform 0.15s ease;
  white-space: nowrap;
  z-index: 30;
}

#accountDate:not([data-range-tooltip=""]):hover::after {
  opacity: 1;
  transform: translateY(0);
}

.sales-filter-panel ::v-deep .sales-filter-field--date-applied {
  min-width: 0;
}

.sales-filter-panel ::v-deep .sales-filter-field--date-applied .e-input-group,
.sales-filter-panel ::v-deep .sales-filter-field--date-applied .e-control-wrapper {
  min-width: 0 !important;
  width: 100% !important;
}

.sales-filter-panel ::v-deep .sales-filter-field--date .e-input-group,
.sales-filter-panel ::v-deep .sales-filter-field--date .e-control-wrapper {
  align-items: center !important;
  display: flex !important;
  overflow: hidden !important;
  gap: 0.25rem !important;
  padding-left: 0.75rem !important;
  padding-right: 0.375rem !important;
  position: relative !important;
}

.sales-filter-panel ::v-deep .sales-filter-field--date .e-input {
  box-sizing: border-box !important;
  color: #334155 !important;
  flex: 1 1 0 !important;
  font-family: inherit !important;
  font-size: 0.625rem !important;
  font-weight: 700 !important;
  height: var(--sales-filter-control-inner-height) !important;
  line-height: var(--sales-filter-control-inner-height) !important;
  max-width: 100% !important;
  min-width: 0 !important;
  overflow: hidden !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  text-align: left !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  width: auto !important;
}

.sales-filter-panel ::v-deep .sales-filter-field--date .e-input::placeholder {
  font-size: 0.75rem !important;
  font-weight: 500 !important;
  text-align: left !important;
}

.sales-filter-panel ::v-deep .sales-filter-field--date .e-float-text,
.sales-filter-panel ::v-deep .sales-filter-field--date .e-label-top {
  display: none !important;
  transform: none !important;
}

.sales-filter-panel ::v-deep .sales-filter-field--date .e-input-group-icon,
.sales-filter-panel ::v-deep .sales-filter-field--date .e-date-icon,
.sales-filter-panel ::v-deep .sales-filter-field--date .e-range-icon {
  flex: 0 0 1.5rem !important;
  height: var(--sales-filter-control-inner-height) !important;
  margin: 0 !important;
  min-width: 1.5rem !important;
  position: static !important;
  transform: none !important;
  width: 1.5rem !important;
}

html.oms-night-mode #accountDate::after {
  background: #fff7ed;
  border-color: #fed7aa;
  box-shadow: 0 0.75rem 1.5rem rgba(0, 0, 0, 0.26);
  color: #9a4f08;
}

.control-styles {
  margin: 0 auto;
  padding-top: 0;
  width: 100%;
}
.minHeight {
  min-height: 18.75rem;
}
.search {
  float: left;
}

.country {
  display: inline-block;
}

.filter {
  padding: 1.25rem;
  margin: 0 auto;
}
.reset {
  margin-top: 0;
}
.gap {
  margin-right: 0;
}
.reset-btn-color {
  background-color: #ffe7c9 !important;
}

.m-t-10 {
  margin-top: 0.625rem;
}

.filter {
  padding: 1.25rem;
  margin: 0 auto;
}
.reset {
  margin-top: 0;
}
.gap {
  position: static;
  right: auto;
  bottom: auto;
  z-index: auto;
}
.reset-btn-color {
  background-color: #ffe7c9 !important;
}
@media (max-width: 96rem) {
  .sales-filter-panel ::v-deep .oms-filter-board__grid {
    grid-template-columns: repeat(4, minmax(10rem, 1fr));
  }
}

@media (max-width: 64rem) {
  .sales-filter-panel ::v-deep .oms-filter-board__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 47.5rem) {
  .sales-filter-panel {
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .sales-filter-panel ::v-deep .oms-filter-board__grid {
    grid-template-columns: 1fr;
  }

  .sales-filter-panel ::v-deep .sales-filter-actions,
  .sales-filter-panel ::v-deep .sales-filter-field--date,
  .sales-filter-panel ::v-deep .reset {
    grid-column: auto;
    min-width: 0;
  }
}
</style>
